import React from "react";

function Delete() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="25"
      height="25"
      enableBackground="new 0 0 512 512"
      viewBox="0 0 32 32"
    >
      <g fill="#d31313">
        <path
          d="M19.5 23.75a1 1 0 001-1v-10a1 1 0 00-2 0v10a1 1 0 001 1zm-7 0a1 1 0 001-1v-10a1 1 0 00-2 0v10a1 1 0 001 1zM20 4.25a1 1 0 000-2h-8a1 1 0 000 2z"
          data-original="#000000"
        ></path>
        <path
          d="M5 5.25a1 1 0 000 2h1v18.4c0 2.26 1.84 4.1 4.1 4.1h11.8c2.26 0 4.1-1.84 4.1-4.1V7.25h1a1 1 0 000-2H7zm19 2v18.4a2.1 2.1 0 01-2.1 2.1H10.1a2.1 2.1 0 01-2.1-2.1V7.25z"
          data-original="#000000"
        ></path>
      </g>
    </svg>
  );
}

export default Delete;
